'use client';

import { ProductCard } from '../cards';
import LoadingProductCard from '../cards/loading-product-card';
import { Swiper, SwiperSlide } from 'swiper/react';
import useProducts from '@/hooks/useProducts';
import Title from '../typography/title';
import { Autoplay, Grid } from 'swiper/modules';
import { useState } from 'react';
import Container from '../container';
import { filterIsInStockProducts } from '@/utils/product';
import useInViewPort from '@/hooks/useInViewPort';
import { event_view_item_list } from '@/utils/gtm';

const ProductsGridSlider = ({ data, isMobile }) => {
  return (
    <Container className='py-0'>
      {data?.value?.map((info, index) => (
        <GridComponent
          key={index}
          index={index}
          isMobile={isMobile}
          data={{ ...data, value: [{ ...info }] }}
        />
      ))}
    </Container>
  );
};

export default ProductsGridSlider;

const GridComponent = ({ data, index, isMobile }) => {
  const { locale, allProducts, isMutating } = useProducts(
    data,
    `grid-${index}`
  );
  const [swiper, set_swiper] = useState({});
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const filteredProducts = filterIsInStockProducts(allProducts);
  const fireViewItemList = () => {
    event_view_item_list(undefined, allProducts);
  };

  const [ref] = useInViewPort(fireViewItemList);
  return filteredProducts?.length ? (
    <div ref={ref} className='md:my-8'>
      <Title
        title={data?.[`title-${locale}`]}
        hasArrows
        swiper={swiper}
        isBeginning={isBeginning}
        isEnd={isEnd}
        locale={locale}
        data={data}
        isMobile={isMobile}
        hasMore
        href={data?.value?.[0]?.url || '#'}
      />
      <div className='sm:mt-4'>
        <Swiper
          onInit={(e) => set_swiper(e)}
          dir={locale === 'en' ? 'ltr' : 'rtl'}
          key={locale}
          modules={[Grid, Autoplay]}
          autoplay={{ delay: 3000, pauseOnMouseEnter: true }}
          onSlideChange={(swiper) => {
            setIsBeginning(swiper.isBeginning);
            setIsEnd(swiper.isEnd);
          }}
          // breakpoints={GridProductsBreakpoints}
          slidesPerView='auto'
          breakpoints={{
            320: { grid: { rows: 1, fill: 'row' }, spaceBetween: 10 },
            720: { grid: { rows: 2, fill: 'row' }, spaceBetween: 10 },
            1024: { grid: { rows: 2, fill: 'row' }, spaceBetween: 25 },
          }}
        >
          {isMutating
            ? [...Array(5).keys()].map((i) => (
                <SwiperSlide
                  key={i}
                  className='max-w-72 min-w-72 sm:max-w-82 sm:min-w-82 lg:max-w-97.5 lg:min-w-97.5'
                >
                  <LoadingProductCard isFromGrid />
                </SwiperSlide>
              ))
            : filteredProducts?.map((product, index) => (
                <SwiperSlide
                  key={index}
                  className='max-w-72 min-w-72 sm:max-w-82 sm:min-w-82 lg:max-w-97.5 lg:min-w-97.5'
                >
                  <ProductCard product={product} isFromGrid />
                </SwiperSlide>
              ))}
        </Swiper>
      </div>
    </div>
  ) : null;
};
